import { AppContext } from "components/AppContext";
import React, { useContext, useEffect } from "react";
import { ExtractReportProvider } from "./ExtractReportContext";
import Page from "./page";

const ExtractReport = () => {
  const { user } = useContext(AppContext);
  useEffect(() => {
    /* global pendo */
    if (user) {
      const selectedAccountDetails = JSON.parse(
        localStorage.getItem("accountDeatils")
      );

      pendo.initialize({
        visitor: {
          id: user?.hstreamid,
          dataextract_userid: user?.userid,
          hstream_email: user?.email
        },

        account: {
          id: selectedAccountDetails?.id,
          name: selectedAccountDetails?.name
        }
      });
    }
  }, [user]);
  return (
    <ExtractReportProvider>
      <Page />
    </ExtractReportProvider>
  );
};

export default ExtractReport;
